import * as actionTypes from "../actionTypes";
export const initStrengths = () => ({
    type: actionTypes.INIT_GET_STRENGTHS,
});
export const getStrengths = () => ({
    type: actionTypes.GET_STRENGTHS,
});

export const getStrengthsSuccess = (payload) => ({
    type: actionTypes.GET_STRENGTHS_SUCCESS,
    payload: payload
});
export const getStrengthsError = () => ({
    type: actionTypes.GET_STRENGTHS_ERROR,
});